import { belowBreakpointOrEqual, fadeColor, getColor, lightenColor, styled } from 'imaginarity-react-ui';

export class MyHomeStartSC {
    public static BGImage = styled.div<{ cw: number }>`
        background-image: url(${props => getColor(props, props.theme.appStart.backgroundUrl)});
        background-repeat: no-repeat;
        background-position: center; 
        background-size: cover;
        position: absolute;
        top: 0px;
        left: 20%;
        transform: translateX(-50%);
        right: 0;
        bottom: 0px;
        /* margin: auto; */
        opacity: 0.5;
        overflow: hidden;
        pointer-events: none;
        z-index: 0;
    `;
    public static OuterContainer = styled.div`
        position: relative;
        margin: auto;
        width:100%;
        height: 100%;
        text-align: left;
    `;
    public static OuterContainerBackgroundImage = styled.div<{ imageUrl: string }>`
        background-image: ${p => p.imageUrl};
        background-repeat: no-repeat;
        background-position: left -23px bottom;
        background-size: cover;
        width:100%;
        height: 128px;
    `;
    public static VideoContainer = styled.div<{ toggleExpand: boolean }>`
        ${p => belowBreakpointOrEqual(p, "mobile") ? "display: block;" : "float:right;"}
        width: ${p => belowBreakpointOrEqual(p, "mobile") ? "100%" : p.toggleExpand ? "100%" : "400px"};
        max-width: ${p => belowBreakpointOrEqual(p, "mobile") ? "100%" : p.toggleExpand ? "100%" : "50%"};
        vertical-align: top;
        margin-left: ${p => belowBreakpointOrEqual(p, "mobile") ? "0px" : p.toggleExpand ? "0px" : "30px"};
        margin-bottom: 30px;
        text-align: center;
        padding: 0;
        position: relative;
        transition: all 0.1s ease-out;
    `;
    public static VideoHint = styled.div`
        position: absolute;
        right: -2em;
        top: 0px;
        cursor: pointer;
        transition: all 0.2s ease-out;
        &:hover{
            svg{
                stroke: ${p => getColor(p, "@accent")};
            }
        }
    `;
    public static Video = styled.video`
        margin: auto;
        outline: none;
        z-index: 10;
        box-shadow: 0 6px 8px -6px ${p => getColor(p, "@darkerGrey")};
    `;
    public static TextContainer = styled.div`
        width:100%;
        text-align: left;
    `;
    public static TextContainerHeader = styled.div`
        margin-bottom: 0.5em;
        font-size: 1.25em;
        font-weight: bolder;
        color: ${p => getColor(p, "@accent")};
    `;
    public static TextContainerText = styled.div`
        font-size: 1.1em;
        color: ${p => getColor(p, "@mainForeground")};
    `;
    public static HighlightHeader = styled.div`
        margin-top: 1.5em;
        font-size: 1.25em;
        margin-bottom: 1em;
        font-weight: bolder;
        color: ${p => getColor(p, "@mainForeground")};
    `;
    public static HighlightListItem = styled.div`
        font-size: 1.1em;
        margin-bottom: 0.5em;
        color: ${p => getColor(p, "@mainForeground")};
        svg{
            stroke: ${p => getColor(p, "@mainForeground")};
        }
    `;
    public static ModuleContainer = styled.div`
        width:100%;
        transition: all 0.2s ease-out;
        background: ${p => getColor(p, "@mainBackground")};
        border: 1px solid ${p => getColor(p, "@mainBackground")};
        cursor: pointer;
        &:hover{
            box-shadow: 0 6px 8px -8px ${p => getColor(p, "@darkerGrey")};
            color: ${p => getColor(p, "@accent")};
            background: ${p => getColor(p, "@veryLightGrey")};
            border: 1px solid ${p => getColor(p, "@middleLightGrey")};
        }
    `;
    public static ModuleContainerImage = styled.img`
        width:100%;
        margin-top: -10px;
    `;
    public static ModuleContainerText = styled.div`
        text-align: center;
        font-size: 1em;
        font-weight: bolder;
        padding-top: 10px;
        color: ${p => getColor(p, "@mainForeground")};
    `;
    public static BtnCont = styled.div`
        position: relative;
        button>div{margin: 0;}
        margin-top: 20px;
    `;
    public static FilteredCount = styled.span`
        float: right;
        color: ${p => fadeColor(p, "@darkGrey", 20)};
        font-weight: 100;
        transition: all 0.2s ease-out;
        &:hover{
            color: ${p => getColor(p, "@lightGrey")};
        }
    `;
    public static MHLPOuterContainerBackgroundImage = styled.div<{ imageUrl: string }>`
        background-image: ${p => p.imageUrl};
        background-repeat: no-repeat;
        background-position: left -140px bottom;
        background-size: cover;
        /* width: calc(110% + 170px); */
        width: 111.12%;
        margin-left: -5.56%;
        //margin-left: -90px;
        /* transform: translate(-5%, -2px); */
        transform: translateY(-2px);
        height: 140px;
    `;
    public static MHLPTitle = styled.div<{ isMobile: boolean }>`
        font-size: ${p => p.isMobile ? 20 : 32}px;
        font-weight: bolder;
        margin-top: 32px;
        opacity: 1;
        color: ${p => getColor(p, "@accentBlack")};
        line-height: 50px;
        font-weight: 700;
        font-style: normal;
        letter-spacing: 0px;
        text-align: left;
        padding: ${p => p.isMobile ? "0 7px" : "0px"};
        button>div{margin: 0;}
        svg{
            stroke-width: 2px;
        }
    `;
    public static MHLPTabContainer = styled.div`
        color: ${p => getColor(p, "@accentBlack")};
        font-size: 16px;
        font-weight: 400;
        font-style: normal;
        letter-spacing: 0px;
        text-align: left;
        line-height: 24px;
        margin-top: 24px;
        width: 100%;
        height: 50px;
        display: grid;
        grid-template-columns: 1fr max-content max-content;
        column-gap: 20px;
    `;
    public static MHLPTabContainerItemLeft = styled.div<{ disabled: boolean, active?: boolean }>`
        color: ${p => getColor(p, p.disabled ? "#D8D8DB" : p.active ? "@accent" : "@accentBlack")};
        //display: inline-block;
        float: left;
        transition: all 0.2s ease-out;
        border-bottom: 1px solid ${p => p.active ? getColor(p, "@accent") : "transparent"};
        cursor: ${p => p.active || p.disabled ? "default" : "pointer"};
        margin-right: 16px;
        &:hover{
            color: ${p => getColor(p, p.disabled ? "#D8D8DB" : "@accent")};
        }
    `;
    public static MHLPTabContainerItemRight = styled.div`
        color: ${p => getColor(p, "@accentBlack")};
        //display: inline-block;
        float: right;
        transition: all 0.2s ease-out;
        border-bottom: 1px solid transparent;
        cursor: ${p => "pointer"};
        &:hover{
            color: ${p => getColor(p, "@accent")};
            svg{
                stroke: ${p => getColor(p, "@accent")};
            }
        }
    `;
    public static MHLPTabContainerItemJobRole = styled.div`
        //display: inline-block;
        float: right;
        //margin-top: -42px;
        //min-width: 200px;
    `;
    public static MHLPTabContainerUsers = styled.div`
        //display: inline-block;
        float: right;
        margin-left: 20px;
        width: 20px;
    `;
    public static MHLPStatusContainerOuter = styled.div<{ statusGap: number }>`
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: ${p => p.statusGap}px;
        width: 100%;
    `;
    public static MHLPStatusContainerTitle = styled.div<{ gcs: number, gce: number }>`
        color: ${p => getColor(p, "@darkGrey")};
        border-bottom: 1px solid ${p => getColor(p, "@middleLightGrey")};
        background: ${p => fadeColor(p, "@veryLightGrey", 50)};
        grid-column-start: ${p => p.gcs};
        grid-column-end: ${p => p.gce};
        line-height: 20px;
        padding: 10px;
        font-weight: bolder;
`;
    public static MHLPStatusContainer = styled.div`
        //margin-top: 29px;
        display: block;
        color: ${p => getColor(p, "@accentBlack")};
        padding: 0 10px;
    `;
    public static MHLPStatusTitle = styled.div`
        opacity: 1;
        color: ${p => getColor(p, "@accentBlack")};
        font-size: 20px;
        font-weight: 500;
        font-style: normal;
        letter-spacing: 0px;
        text-align: left;
        line-height: 31px;
    `;

    public static MHLPStatusInfo = styled.div<{ color: string }>`
        color: ${p => getColor(p, p.color)};
        opacity: 1;
        font-size: 14px;
        font-weight: 600;
        font-style: normal;
        letter-spacing: 0px;
        text-align: left;
        line-height: 20px;
    `;
    public static MHLPStatusBarContainer = styled.div`
        margin-top: 32px;
        border-radius: 1.5px;
        margin-bottom: 30px;
        position: relative;
        height: 2px;
        width: 100%;
        opacity: 1;
        background-color: rgba(227,228,229, 1);


    `;
    public static MHLPStatusBar = styled.div<{ percentage: number, color: string }>`
        position: absolute;
        top: 0;
        border-radius: 1px;
        bottom: 0;
        left: 0;
        width: ${p => p.percentage}%;
        background: ${p => getColor(p, p.color)};
    `;
    public static MHLPStatusBarDot = styled.div<{ percentage: number, color: string }>`
        position: absolute;
        top: -3px;
        border-radius: 3px;
        left: ${p => p.percentage}%;
        width: 6px;
        height: 6px;
        padding: 2px;
        //background: ${p => lightenColor(p, p.color, 80)};
        background: #fff;
        transform: translateX(-100%);
        border: 2px solid ${p => getColor(p, p.color)};
    `;
    public static MHLPStatusPercentage = styled.div`

        opacity: 1;
        color: ${p => getColor(p, "@accentBlack")};
        font-size: 32px;
        font-weight: 700;
        font-style: normal;
        letter-spacing: 0px;
        text-align: left;
        margin-top: 24px;
        line-height: 50px; 
    `;
    public static MHLPStatusPercentageInfo = styled.div`
        opacity: 1;
        color: ${p => getColor(p, "@accentBlack")};
        font-size: 12px;
        font-weight: 400;
        font-style: normal;
        letter-spacing: 0px;
        text-align: left;
        

    `;
    public static CarouselContainer = styled.div`
        position: relative;
        margin-top: 19px;
        width: 100%;
        *:focus {
            outline: 0;
        }
        .slider-control-bottomcenter {
            position: absolute;
            bottom: -20px;
            left: 50%;
            transform: translateX(-50%);
        
            ul {
                position: relative;
                display: flex;
                margin: 0px;
                padding: 0px;
                list-style-type: none;
            
                li {
                    button {
                        cursor: pointer;
                        opacity: 1;
                        background: transparent;
                        border: none;
                        fill: ${p => getColor(p, p.theme.colors.middleLightGrey)};
                        padding: 1px 6px;
                        margin: 0 -6px;
                        svg{
                            transform: scale(0.5);
                        }
                        &:hover{
                            fill: ${p => getColor(p, p.theme.colors.accent)};
                        }
                    }
                }
            }
    
            .active {
                button {
                    fill: ${p => getColor(p, p.theme.colors.lightGrey)} !important;
                }
            }
        }
    `;
    public static CarouselButtonRight = styled.div<{ disabled: boolean }>`
        position: absolute;
        right: -7px;
        top: -50px;
        svg{
            stroke: ${p => getColor(p, p.disabled ? "@disabled" : "@accentBlack")};
            transition: all 0.2s ease-out;
            cursor: ${p => p.disabled ? "default" : "pointer"};
            &:hover{
                stroke: ${p => getColor(p, p.disabled ? "@disabled" : "@accent")};
            }
        }
    `;
    public static CarouselButtonLeft = styled(this.CarouselButtonRight)`
        right: 41px;
    `;
    public static CarouselSlideContainerOuter = styled.div<{ img: string }>`
        position: relative;
        width: 100%;
        aspect-ratio: 16 / 9;
        background: #fff;
        background-image: url(${p => p.img});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        transition: all 0.2s ease-out;
        overflow: hidden;
        &::before{
            content:"";
            position: absolute; 
            top:0;
            right:0;
            bottom:0;
            left:0;
            background:inherit;
            transition: inherit;
        }
        &:hover::before { 
            transform: scale(1.1);
          }

          opacity: 1;
    `;
    public static CarouselSlideContainer = styled.div`
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: transparent;
        //background-image: linear-gradient(180deg, rgba(14, 20, 24, 0) 0%, rgba(14, 20, 24, 0.9) 100%);
        background: linear-gradient(to top, rgba(31, 31, 31, 0.9) 0%, rgba(31, 31, 31, 0.9) 20%, rgba(31, 31, 31, 0.85) 26.67%, rgba(32, 32, 32, 0.77) 33.33%, rgba(33, 33, 33, 0.667) 40%, rgba(34, 34, 34, 0.557) 46.67%, rgba(35, 35, 35, 0.443) 53.33%, rgba(36, 36, 36, 0.333) 60%, rgba(37, 37, 37, 0.23) 66.67%, rgba(38, 38, 38, 0.15) 73.33%, rgba(39, 39, 39, 0.082) 80%, rgba(39, 39, 39, 0.035) 86.67%, rgba(39, 39, 39, 0.008) 93.33%, rgba(39, 39, 39, 0) 100%);
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 1fr max-content max-content;
        align-items: end;
        text-shadow: 1px 1px 2px #000;
    `;
    public static CarouselSlideContainerOverdue = styled.div`
        position: absolute;
        top: 10px;
        right: 10px;
        background: ${p => fadeColor(p, "@mainBackground", 100)};
        border: 1px solid ${p => fadeColor(p, "@mainBackground", 50)};
        width: 30px;
        height: 30px;
        border-radius: 50%;
        text-align: center;
        line-height: 30px;
    `;
    public static CarouselSlideContainerTitle = styled.div`
        padding: 0 20px;
        color: ${p => getColor(p, "@mainBackground")};
        opacity: 1;
        font-size: 16px;
        font-weight: 600;
        font-style: normal;
        letter-spacing: 0px;
        text-align: left;
        line-height: 22px;
    `;
    public static CarouselSlideContainerInfo = styled.div<{ overdue: boolean }>`
        //padding: 0 20px 7px 20px;
        padding: 0 20px;
        //color: ${p => getColor(p, p.overdue ? "@accent" : "@mainBackground")};
        color: ${p => getColor(p, "@mainBackground")};
        //background: ${p => p.overdue ? fadeColor(p, "@mainBackground", 60) : "@mainBackground"};
        background: ${p => p.overdue ? fadeColor(p, "@accent", 40) : "@mainBackground"};
        text-shadow: ${p => p.overdue ? "none" : "inherit"};
        opacity: 1;
        font-size: 12px;
        font-weight: 400;
        font-style: normal;
        letter-spacing: 0px;
        text-align: left;
`;
    public static CarouselSlideContainerStatusBarContainer = styled.div<{ show: boolean }>`
        position: relative;
        height: 1px;
        width: calc(100% - 40px);
        margin-left: 20px;
        background: ${p => p.show ? fadeColor(p, "@mainBackground", 20) : "transparent"};
        margin-bottom: 16px;
    `;
    public static CarouselSlideContainerStatusBar = styled.div<{ percentage: number, color?: string }>`
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: ${p => p.percentage}%;
        background: ${p => getColor(p, p.color ?? (p.percentage < 100 ? "@accent" : "@accentGreen"))};
    `;


    public static MYLPDDContainer = styled.div`
        margin-top: 30px;
        display: grid;
        column-gap: 0px;
        row-gap: 0px;
        padding-bottom: 100px;
        button>div{
            margin: 0;
        }
    `;

    public static MYLPDDCTitle = styled.div`
        cursor: pointer;
        transition: all 0.2s ease-out;
        opacity: 1;
        color: ${p => getColor(p, "@darkGrey")};
        font-size: 14px;
        font-weight: 600;
        font-style: normal;
        letter-spacing: 0px;
        text-align: left;
        line-height: 20px;
        //border-bottom: 1px solid #E6E6E7;
        margin-bottom: -6px;
        outline: none;
        button{
            outline: none;
            float: unset !important;
            /* display: inline-block !important; */
            margin-left: -8px;
            transform: translateY(4px);
        }
        &:hover{
            color: ${p => getColor(p, "@accent")};
            svg{
                stroke:  ${p => getColor(p, "@accent")};
            }
        }
        svg{
            stroke:  ${p => getColor(p, "@darkGrey")};
            width: 14px;
            height: 14px;
            transform: translateY(-1px);
        }
    `;
    public static MYLPDDCTitleNoEffect = styled(this.MYLPDDCTitle) <{ search: boolean }>`
    cursor: default;
    svg{
        stroke: ${p => getColor(p, "@middleLightGrey")};
        margin-top: 2px;
    }
    *{
        border-bottom-color: ${p => p.search ? getColor(p, "@accent") : "inherit"} !important;
    }
    &:hover{
        color: unset;
        svg{stroke: ${p => getColor(p, "@accent")}}
}
`;
    public static MYLPDDCDivider = styled.div<{ empty: boolean; gcs: number, gce: number, top: number }>`
        height: 40px;
        line-height: 40px;
        grid-column-start: ${p => p.gcs};
        grid-column-end: ${p => p.gce};
        user-select: none;
        width: 100%;
        padding-left: calc(${p => p.theme.sidebars.padding.left / 2 + "%"} - 9px);
        font-weight: bolder;
        margin-top: 0px;
         border-top: 1px solid ${p => getColor(p, "@middleLightGrey")};
        background-color: #FAF9FB;
        color: ${p => getColor(p, p.empty ? "@darkGrey" : "@accentGreen")};
        font-size: 1em;
        font-weight: ${p => p.empty ? 600 : 500};
        font-style: normal;
        letter-spacing: 0px;
        text-align: left;
        position: sticky;
        top: ${p => p.top}px;
    `;

    public static MYLPDDCSpacer = styled.div`
        height: 12px;
        grid-column-start: 1;
        grid-column-end: 10;
    `;

    public static MYLPDDCDividerCount = styled.div<{ done: boolean }>`
        float: left;
        font-weight: normal;
        color: ${p => getColor(p, p.done ? "@accentGreen" : "@middleLightGrey")};
    `;
    public static MYLPDDCThumb = styled.div`
        grid-column-start: 2;
        grid-column-end: 3;
        width: 100%;
        &>div{border: none;}
    `;
    public static MYLPDDCNoEntries = styled.div`
        grid-column-start: 2;
        grid-column-end: 5;
        width: 100%;
        color: ${p => getColor(p, "@darkGrey")};
        padding-left: 15px;
        margin-bottom: -10px;
    `;
    public static MYLPDDCCell = styled.div<{ large: boolean, color?: string }>`
        width: 100%;
        line-height: ${p => p.large ? 48 : 40}px;
        color: ${p => p.color ? getColor(p, p.color) : getColor(p, "@darkGrey")};
        opacity: 1;
        font-size: 14px;
        font-weight: 400;
        font-style: normal;
        letter-spacing: 0px;
        text-align: left;
        //padding-right: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        transition: all 0.2s ease-out;
        `;
    public static MYLPDDCCellTitle = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${p => getColor(p, "@darkerGrey")};
    width: 100%;
    cursor: pointer;
    transition: all 0.2s ease-out;
    border-left: 1px solid transparent;

    &:hover{
        color: ${p => getColor(p, "@accent")};
        background: linear-gradient(to right, ${p => getColor(p, "@veryLightGrey")} 50%, ${p => fadeColor(p, "@veryLightGrey", 0)} 100%);

        padding-left: 10px;
        border-left: 1px solid ${p => getColor(p, "@accent")};
    }
    `;
    public static MYLPDDCCellTitleCrop = styled.span<{ showLpTitle: boolean }>`
    width: calc(100% - ${p => p.showLpTitle ? 40 : 0}px);
    float: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
    public static MYLPDDCCellId = styled.div`
        &:hover{
            svg{
                stroke: ${p => getColor(p, "@accent")};
            }
        }
    `;
    public static NotificationContainer = styled.div`
        padding: 16px;
        background: rgb(211, 225, 255);
        overflow-wrap: break-word;
        hyphens: auto;
        color: rgb(1, 2, 5);
    `;
    public static AdminInfo = styled.span`
        float: right;
        color: ${p => fadeColor(p, "@veryLightGrey", 70)};
        font-weight: 100;
        svg{
        stroke: ${p => fadeColor(p, "@veryLightGrey", 70)};
        }
    `;
    public static AdminConatiner = styled.div`
        padding: 10px;
        border: 1px solid ${p => getColor(p, "@darkGrey")};
        background: ${p => fadeColor(p, "@veryLightGrey", 50)};
        margin-top: 20px;
        box-shadow: 0 6px 8px -6px ${p => getColor(p, "@darkGrey")};
    `;
    public static AdminConatinerInfo = styled.div`
       margin-bottom: 10px;
       color: ${p => getColor(p, "@accent")}; 
       font-weight: bolder;
       text-transform: uppercase;
       height: 40px;
       line-height: 40px;
       background: ${p => getColor(p, "@veryLightGrey")}; 
       border-bottom: 1px solid ${p => getColor(p, "@middleLightGrey")}; 
       width: calc(100% + 20px);
       margin-left: -10px;
       margin-top: -10px;
       padding-left: 10px;
    `;
    public static AdminConatinerButtons = styled.div`
       display: grid;
       grid-template-columns: 200px 40px 40px repeat(4, max-content) 1fr max-content;
       column-gap: 5px;
       button>div{margin: 0;}
    `;
    public static AdminConatinerGrid = styled.div`
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 20px;
        margin-top: 0px;
    `;
    public static AdminConatinerGridTitle = styled.div`
        border-bottom: 1px solid ${p => getColor(p, "@middleLightGrey")};
        background: ${p => getColor(p, "@veryLightGrey")}; 
        line-height: 40px;
        height: 40px;
        margin-bottom: -40px;
        font-weight: bolder;
        padding-left: 20px;
    `;
    public static AdminConatinerGridTableTop = styled.div`
        margin-top: 0px;
        grid-column-start: 1;
        grid-column-end: 3;
        line-height: 40px;
    `;
    public static AdminConatinerGridTableTopButtons = styled.div`
        display: grid;
        grid-template-columns: 120px 160px 170px max-content;
        column-gap: 0px;
        margin-top: -10px;
        margin-right: -10px;
        float: right;
    `;
    public static AdminConatinerTable = styled.div`
        margin-top: 10px;
        font-size: smaller;
    `;
    public static AdminConatinerTableContainer = styled.div`
        color: ${p => getColor(p, "@accent")};
        font-weight: bolder;
        margin-bottom: -1px;
        background: ${p => getColor(p, "@veryLightGrey")};
        padding: 10px;
        border: 1px solid #DBD8E2;
        border-bottom: none;
    `;


}